import { useSelector } from 'react-redux';

import { currentOpenChatSelector, isShowSubAgentChatListSelector, userIdSelector } from '../../../selectors';

type TUseUserName = {
  messageUserId: number;
  isFirstUserPhrase: boolean;
};

export const useUserName = ({
  messageUserId,
  isFirstUserPhrase,
}: TUseUserName): { userName: string | undefined; nameReplacementImageUrl: string | undefined } => {
  const userId = useSelector(userIdSelector);
  const { users = [] } = useSelector(currentOpenChatSelector) || {};
  const isShowSubAgentChatList = useSelector(isShowSubAgentChatListSelector);

  const currentUser = users.find(user => user.userId === userId);
  const messageUser = users.find(user => user.userId === messageUserId);

  // Если сообщение не первое в перифразе,
  // Если текущий пользователь - отправитель, не участник чата
  //  - имя и лого не отображаем
  if (!isFirstUserPhrase || !messageUser) {
    return { userName: undefined, nameReplacementImageUrl: undefined };
  }

  const messageUserName = messageUser?.name || `id ${messageUserId}`;

  // 0. Автор сообщения - БЕЗ имени
  if (userId === messageUserId) {
    return { userName: undefined, nameReplacementImageUrl: undefined };
  }

  // 1. Если в чате есть компаньон - С именами у всех участников
  if (users.some(user => user.chatRole === 'companion')) {
    const agentUser = users.find(user => user.chatRole === 'opponent');

    // 1.1 Я - инициатор или компаньон, сообщение от мастера - выводим имя агента мастера, если агент есть
    if (
      (currentUser?.chatRole === 'initiator' || currentUser?.chatRole === 'companion') &&
      messageUser.chatRole === 'master' &&
      agentUser
    ) {
      return {
        userName: agentUser.name || `id ${agentUser.userId}`,
        nameReplacementImageUrl: agentUser.nameReplacementImageUrl,
      };
    }

    return { userName: messageUserName, nameReplacementImageUrl: messageUser.nameReplacementImageUrl };
  }

  // 2. В остальных случаях:

  // 2.1 Я — инициатор. В моих глазах
  // Мои сообщения, оппонента и мастера БЕЗ имени
  if (currentUser?.chatRole === 'initiator') {
    return { userName: undefined, nameReplacementImageUrl: undefined };
  }

  // 2.2 Я — оппонент. В моих глазах
  // Сообщения инициатора БЕЗ имени
  // Сообщения мастера С именем
  if (currentUser?.chatRole === 'opponent') {
    return messageUser.chatRole === 'initiator'
      ? { userName: undefined, nameReplacementImageUrl: undefined }
      : { userName: messageUserName, nameReplacementImageUrl: messageUser.nameReplacementImageUrl };
  }

  // 2.3 Я — мастер (участник чата, либо смотрю чат субагента). В моих глазах
  // Сообщения инициатора БЕЗ имени
  // Сообщения оппонента С именем
  if (currentUser?.chatRole === 'master' || isShowSubAgentChatList) {
    return messageUser.chatRole === 'initiator'
      ? { userName: undefined, nameReplacementImageUrl: undefined }
      : { userName: messageUserName, nameReplacementImageUrl: messageUser.nameReplacementImageUrl };
  }

  return { userName: undefined, nameReplacementImageUrl: undefined };
};
